module.exports = __webpack_public_path__ + "static/media/DSC_0468.facf3448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0468.jpg
// module id = 669
// module chunks = 0